<form id="beneficiario" class="row form-beneficiary-styles first-container-identification-xs m-t-34 m-t-xs-40 m-b-29 form-width-size" [formGroup]="form" (ngSubmit)="saveStepTwo($event)" autocomplete="off">
  <div class="col-12 m-b-36 d-flex justify-content-between align-items-start">
    <div class="container-return-style align-self-start">
      <img class="img-return-blue" [src]="url_img.return_blue" alt="" (click)="previous('I')">
    </div>
    <app-header-steps></app-header-steps>
  </div>
  <div class="col-12 m-b-20">
    <div class="">
      <div class="d-block w-100">
        <p class=" heading-b-m-24 text-start line-height-20 text-start m-b-20">
          Beneficiario
        </p>
        <p class=" paragraph-b-r-16 text-start line-height-20 m-b-8">
          Debe ser mayor de edad.<br>
          Es quien recibirá el 100% de los recursos en caso de fallecimiento del titular de la cuenta.
        </p>
      </div>
    </div>
  </div>

  <div class="col-12 m-b-20">
    <div [ngClass]="{'input-error-style': nameInput.invalid && nameInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
        Nombre
      </label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text"
              only-letters
              oninput="this.value = this.value.toUpperCase()"
              formControlName="nombre" 
              maxlength="50"
              autocomplete="off">
      <p class="text-error-style d-flex align-items-center" *ngIf="nameInput.invalid && nameInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>
  <div class="col-6 m-b-20">
    <div [ngClass]="{'input-error-style': fSurnameInput.invalid && fSurnameInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
        Apellido paterno
      </label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text"
              only-letters
              oninput="this.value = this.value.toUpperCase()"
              formControlName="aPaterno" 
              maxlength="50"
              autocomplete="off">
      <p class="text-error-style d-flex align-items-center" *ngIf="fSurnameInput.invalid && fSurnameInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>
  <div class="col-6 m-b-20">
    <div [ngClass]="{'input-error-style': sSurnameInput.invalid && sSurnameInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
        Apellido materno
      </label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text"
              only-letters
              oninput="this.value = this.value.toUpperCase()"
              formControlName="aMaterno" 
              maxlength="50"
              autocomplete="off">
      <p class="text-error-style d-flex align-items-center" *ngIf="sSurnameInput.invalid && sSurnameInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>

  <div class="col-12 m-b-40">
    <div [ngClass]="{'input-error-style': relationshipInput.invalid && relationshipInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
        Parentesco
      </label>
      <select class="form-control select-field-style " formControlName="parentescoVal" (change)="setValueRelationship()">
        <option value=""></option>
        <option *ngFor="let option of typesRelationship; let i = index" [value]="i">{{option.value | titlecase}}</option>
      </select>

      <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
      <div ngbDropdown class="button-dropdown-style d-none w-240">
        <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
          <span>Elige otro</span> <img class="img-arrowdown-blue" [src]="url_img.arrowdown_blue" alt="">
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
          <button ngbDropdownItem>Another Action</button>
          <button ngbDropdownItem>Something else is here</button>
        </div>
      </div>


      <p class="text-error-style d-flex align-items-center" *ngIf="relationshipInput.invalid && relationshipInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>

  <div class="col-12 col-md-6 m-b-40"> 
    
      <label for="" class="paragraph-b-r-16 mb-2">
        Fecha de nacimiento
      </label>
      <div class="input-date-style d-flex justify-content-start align-items-center">
        <div [ngClass]="{'input-error-style': birthDayInput.invalid && birthDayInput.touched && this.birthDayInput.dirty }">
          <div class="input-date-day input-date-error">
            <label class="paragraph-b-r-16 mb-1" for="">Día</label>
            <input  class="form-control input-field-style width-50 m-r-20 text-center" 
                    placeholder="DD" 
                    type="text"
                    only-number
                    formControlName="fechaNacBnfcrDD" 
                    maxlength="2"
                    autocomplete="off"
                    (change)="validateDayBirth()">
          </div>
        </div>
        <div [ngClass]="{'input-error-style': birthMonthInput.invalid && birthMonthInput.touched &&  birthMonthInput.dirty}">
          <div class="input-date-moth input-date-error">
            <label class="paragraph-b-r-16 mb-1" for="">Mes</label>
            <input  class="form-control input-field-style width-50 m-r-20 text-center" 
                    placeholder="MM" 
                    type="text"
                    only-number
                    formControlName="fechaNacBnfcrMM" 
                    maxlength="2"
                    autocomplete="off"
                    (change)="validateMonthBirth()">
          </div>
        </div>
        <div [ngClass]="{'input-error-style': birthYearInput.invalid && birthYearInput.touched &&  birthYearInput.dirty }">
          <div class="input-date-year input-date-error">
            <label class="paragraph-b-r-16 mb-1" for="">Año</label>
            <input  class="form-control input-field-style width-70 text-center" 
                    placeholder="AAAA" 
                    type="text"
                    only-number
                    formControlName="fechaNacBnfcrYYYY" 
                    maxlength="4"
                    autocomplete="off">
          </div>
        </div>
      </div>
      <div [ngClass]="{'input-error-style': showErrorBrithDate()}">
        <p class="text-error-style d-flex align-items-center" *ngIf="showErrorBrithDate()">
          <img class="circle-error-tomato" [src]="url_img.alert" alt=""> {{msgErrorBirthDate}}
        </p>
      </div>
  </div>

  <div class="col-12 m-b-40">
    <div [ngClass]="{'input-error-style': sameAddressInput.invalid && sameAddressInput.touched }">
      <p class=" paragraph-b-r-16 text-start line-height-20 m-b-12">
        ¿El beneficiario tiene el mismo domicilio que tú?
      </p>
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="mismoDomicilio1">Sí
          <input class="form-check-input" type="radio" formControlName="mismoDomicilio" id="mismoDomicilio1" value="SI" (ngModelChange)="showHideAddress()">
          <span class="checkmark"></span>
        </label>
      </div>
      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="mismoDomicilio2">No
          <input class="form-check-input" type="radio" formControlName="mismoDomicilio" id="mismoDomicilio2" value="NO" (ngModelChange)="showHideAddress()">
          <span class="checkmark"></span>
        </label>
      </div>

      <p class="text-error-style d-flex align-items-center" *ngIf="sameAddressInput.invalid && sameAddressInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt="">Elige una opción para continuar
      </p>
    </div>
  </div>
  <!-- Inicia Fomrulario de Domicilio -->
  
  <div class="col-12 m-b-20" [hidden]="showAddress">
    <div class="">
      <div class="d-block w-100">
        <p class=" heading-b-m-24 text-start line-height-20 text-start mb-0">
          Dirección del beneficiario
        </p>      
      </div>
    </div>
  </div>

  <div class="col-12 m-b-20" [hidden]="showAddress">
    <div class="container-bottom-dynamic" [ngClass]="{'input-error-style': (typeAddressRadio.invalid && typeAddressRadio.touched) || ((typeAddressSelect.invalid && typeAddressSelect.touched)) }">
      
      <div class="form-check radio-style-form radio-repet-bottom" *ngFor="let item of typesAddressRadio">
        <label class="form-check-label radio-content " for="occupation_{{item.id}}">{{item.value | titlecase}}
          <input class="form-check-input" type="radio" formControlName="tipoDomicilioRadio" id="occupation_{{item.id}}" [value]="item.id" (change)="setRequiredOptions()">
          <span class="checkmark"></span>
        </label>
      </div>

      <div class="form-check form-check-inline radio-style-form m-b-5">
        <label class="form-check-label radio-content " for="occupation">
          <select class="paragraph-b-r-16 select-field-style width-240" formControlName="tipoDomicilioSelect" (change)="setAnotherOption()">
            <option value="">Elige otro</option>
            <option *ngFor="let option of typesAddressSelect" value="{{option.id}}">{{option.value | titlecase}}</option>
          </select>
          <input class="form-check-input" type="radio" formControlName="tipoDomicilioRadio" id="occupation" value="0" (change)="setRequiredOptions()">
          <span class="checkmark top-10"></span>
        </label>
      </div>
      <p class="text-error-style d-flex align-items-center" *ngIf="(typeAddressRadio.invalid && typeAddressRadio.touched) || ((typeAddressSelect.invalid && typeAddressSelect.touched))">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>
  
  <div class="col-12 col-sm-4 col-md-4 m-b-20" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': postalCodeInput.invalid && postalCodeInput.touched }">
      <label for="" class="paragraph-b-r-16 white-space-nowrap mb-1">
        Código postal
      </label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text"
              only-number
              formControlName="codigoPostal" 
              maxlength="5"
              autocomplete="off"
              (ngModelChange)="updaPostalCode()">
      <p class="text-error-style d-flex align-items-center" *ngIf="postalCodeInput.invalid && postalCodeInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>
  <div class="d-block w-100 d-sm-none"></div>
  <div class="col-6 col-sm-4 col-md-4 m-b-20" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': numExtInput.invalid && numExtInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
        Número ext.
      </label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text"
              only-alphanumeric
              oninput="this.value = this.value.toUpperCase()"
              formControlName="numeroExt" 
              maxlength="50"
              autocomplete="off">
      <p class="text-error-style d-flex align-items-center" *ngIf="numExtInput.invalid && numExtInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>
  <div class="col-6 col-sm-4 col-md-4 m-b-20" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': numIntInput.invalid && numIntInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
        Número int.
      </label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text"
              only-alphanumeric
              oninput="this.value = this.value.toUpperCase()"
              formControlName="numeroInt" 
              maxlength="50"
              autocomplete="off">
      <p class="text-error-style d-flex align-items-center" *ngIf="numIntInput.invalid && numIntInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>
  <div class="d-block w-100 d-md-none"></div>
  <div class="  col-6 m-b-20" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': countryInput.invalid && countryInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
          País
      </label>
      <select class="form-control select-field-style" formControlName="paisVal" (change)="setValueCountry()">      
        <option value = ""></option>
        <option *ngFor="let country of countries; let i = index" value="{{i}}">{{country.value | titlecase}}</option>
      </select>

       <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
      <div ngbDropdown class="button-dropdown-style d-none w-240">
        <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
          <span>Elige otro</span> <img class="img-arrowdown-blue" [src]="url_img.arrowdown_blue" alt="">
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
          <button ngbDropdownItem>Another Action</button>
          <button ngbDropdownItem>Something else is here</button>
        </div>
      </div>

      <p class="text-error-style d-flex align-items-center" *ngIf="countryInput.invalid && countryInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>

  <div class="col-6 m-b-20" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': estateInput.invalid && estateInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
          Estado
      </label>
      <select class="form-control select-field-style " formControlName="estado" (change)="setValueEstate()" readonly>
        <option *ngFor="let estate of estatesShort; let i = index" value="{{i}}">{{estate.bezei | titlecase}}</option>
      </select>

      <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
      <div ngbDropdown class="button-dropdown-style d-none w-240">
        <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
          <span>Elige otro</span> <img class="img-arrowdown-blue" [src]="url_img.arrowdown_blue" alt="">
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
          <button ngbDropdownItem>Another Action</button>
          <button ngbDropdownItem>Something else is here</button>
        </div>
      </div>

      <p class="text-error-style d-flex align-items-center" *ngIf="estateInput.invalid && estateInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>

  <div class="col-12 m-b-20" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': cityInput.invalid && cityInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
      Cuidad o población
      </label>
      <select class="form-control select-field-style " formControlName="ciudad" (change)="setValueCity()">
        <option value=""></option> 
        <option *ngFor="let city of cities; let i = index" value="{{i}}">{{city.descripcion | titlecase}}</option>           
      </select>

      <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
      <div ngbDropdown class="button-dropdown-style d-none w-240">
        <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
          <span>Elige otro</span> <img class="img-arrowdown-blue" [src]="url_img.arrowdown_blue" alt="">
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
          <button ngbDropdownItem>Another Action</button>
          <button ngbDropdownItem>Something else is here</button>
        </div>
      </div>

      <p class="text-error-style d-flex align-items-center" *ngIf="cityInput.invalid && cityInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>

  <div class="col-12 m-b-20" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': townInput.invalid && townInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
          Municipio o alcaldía
      </label>
      <select class="form-control select-field-style " formControlName="delegacion" (change)="setValueTown()" readonly>
        <option *ngFor="let town of towns; let i = index" value="{{i}}">{{town.xlbez | titlecase}}</option>
      </select>

      <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
      <div ngbDropdown class="button-dropdown-style d-none w-240">
        <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
          <span>Elige otro</span> <img class="img-arrowdown-blue" [src]="url_img.arrowdown_blue" alt="">
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
          <button ngbDropdownItem>Another Action</button>
          <button ngbDropdownItem>Something else is here</button>
        </div>
      </div>

      <p class="text-error-style d-flex align-items-center" *ngIf="townInput.invalid && townInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>

  <div class="col-12 m-b-20" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': suburbInput.invalid && suburbInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
          Colonia
      </label>
      <select class="form-control select-field-style " formControlName="colonia" (change)="setValueSuburb()">     
        <option></option>
        <option *ngFor="let suburb of suburbs; let i = index" value="{{i}}">{{suburb.colonia | titlecase}}</option>
      </select>

      <!--?Nuevo select para verlo regresar a d-block la clase d-none-->
      <div ngbDropdown class="button-dropdown-style d-none w-240">
        <div class="button-generic-style button-outline button-drop-style text-start width-240 height-40 d-flex justify-content-between align-items-center p-y-11" id="dropdownBasic1" ngbDropdownToggle> 
          <span>Elige otro</span> <img class="img-arrowdown-blue" [src]="url_img.arrowdown_blue" alt="">
        </div>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-container-style">                
          <button ngbDropdownItem>Another Action</button>
          <button ngbDropdownItem>Something else is here</button>
        </div>
      </div>

      <p class="text-error-style d-flex align-items-center" *ngIf="suburbInput.invalid && suburbInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>

  <div class="col-12 m-b-40" [hidden]="showAddress">
    <div [ngClass]="{'input-error-style': streetInput.invalid && streetInput.touched }">
      <label for="" class="paragraph-b-r-16 mb-2">
        Calle
      </label>
      <input  class="form-control input-field-style" 
              placeholder="" 
              type="text"
              only-alphanumeric
              oninput="this.value = this.value.toUpperCase()"
              formControlName="calle" 
              maxlength="100"
              autocomplete="off">
      <p class="text-error-style d-flex align-items-center" *ngIf="streetInput.invalid && streetInput.touched">
        <img class="circle-error-tomato" [src]="url_img.alert" alt=""> Dato requerido
      </p>
    </div>
  </div>
  
  <!-- Fin Fomrulario de Domicilio -->

  <div class="col-6 text-start">
    <div class="m-b-29">
      <button class="button-generic-style button-outline height-48 w-100" (click)="previous('')">Regresar</button>
    </div>
  </div>
  <div class="col-6 text-end">
    <div class="m-b-29">
      <button class="button-generic-style button-blue height-48 w-100" [disabled]="form.invalid">Continuar</button>
    </div>
  </div>
</form>
